
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/snapline.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-xflow-components-snapline-demo-xflow-components-snapline"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/snapline.en.md?type=demo')
};